import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, styled, } from '@mui/material';
import React from 'react';
export const Accordion = styled((props) => (React.createElement(MuiAccordion, Object.assign({ disableGutters: true, elevation: 0, square: true }, props), props.children)))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));
export const AccordionSummary = styled((props) => (React.createElement(MuiAccordionSummary, Object.assign({ expandIcon: React.createElement(ArrowForwardIosSharpIcon, { sx: { fontSize: '0.9rem' } }) }, props))))(({ theme }) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
}));
export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '100px 100px',
    gridGap: theme.spacing(2),
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .025)' : 'rgba(0, 0, 0, .015)',
}));
